(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-label"] && !Shopify.designMode) return;
  try {
    (function () {
    function setFullscreen(modal, on) {
      var button = modal.querySelector('[data-label-fullscreen]');
      modal.classList.toggle('is-fullscreen', on);
      if (!button) return;
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.setAttribute('aria-label', on ? button.dataset.labelCollapse : button.dataset.labelExpand);
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-label-fullscreen]');
      if (!button) return;
      var modal = button.closest('.modal--label');
      if (modal) setFullscreen(modal, !modal.classList.contains('is-fullscreen'));
    });

    document.addEventListener('dialog:after-hide', function (event) {
      if (event.target.classList && event.target.classList.contains('modal--label')) {
        setFullscreen(event.target, false);
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('sticky-atc-bar')) {
    class StickyAtcBar extends HTMLElement {
      connectedCallback() {
        this.onScroll = this.onScroll.bind(this);
        this.ticking = false;
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        this.resizeObserver = new ResizeObserver(() => {
          document.documentElement.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
        });
        this.resizeObserver.observe(this);

        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.resizeObserver?.disconnect();
        document.documentElement.style.removeProperty('--sticky-atc-height');
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      }

      update() {
        const form = document.getElementById(this.getAttribute('main-product-form'));
        if (!form) return;
        this.classList.toggle('is-visible', form.getBoundingClientRect().bottom < 0);
      }
    }

    window.customElements.define('sticky-atc-bar', StickyAtcBar);
  }
  } catch(e) { console.error(e); }
})();

})();
